/**
 * callback gets called when no error occurs
 * @param {SubmitEvent} evt
 * @param {Function} callback
 * @returns {void}
 */
window.sfFormHandler = async (evt, callback) => {
  evt.preventDefault();
  const button = evt.submitter;
  button.setAttribute('style', 'display: none');
  const form = evt.target;
  const mouseflowId = `#${form.id}`;
  if (mouseflowId) {
    window._mfq = window._mfq || [];
    window._mfq.push(['formSubmitAttempt', mouseflowId]);
  }
  const inputElements = form.querySelectorAll('input, select, textarea');
  const endpoint = form.getAttribute('data-endpoint');
  const formId = form.querySelector("input[type='hidden'][name='formId']").value;
  const data = {};
  sfShowLoadingIndicator(form);
  for (const element of inputElements) {
    if (element.offsetWidth === 0 && element.offsetHeight === 0 && element.type !== 'hidden') {
      continue;
    }
    if ((element.type === 'radio' || element.type === 'checkbox') && element.checked === false) {
      continue;
    }
    const name = element.getAttribute('name');
    const val = element.value;
    const existingVal = data[name];
    if (existingVal != null) {
      if (Array.isArray(existingVal)) {
        existingVal.push(val);
      } else {
        data[name] = [existingVal, val];
      }
    } else {
      data[name] = val;
    }
  }
  // Scope the reCAPTCHA lookup to the submitted form: a page can contain
  // several Salesforce forms (e.g. contact + Widerruf), each with its own
  // widget. document.getElementById('g-recaptcha-response') would always
  // return the first widget, so a second form would submit an empty token.
  let google = form.querySelector("textarea[name='g-recaptcha-response']");
  if (google !== null) {
    data['recaptcha'] = google.value;
  } else {
    data['recaptcha'] = '';
  }
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  const resultDivs = document.querySelectorAll('.result-' + formId);
  const contentType = response.headers.get('content-type');
  let hasError = false;
  if (contentType && contentType.indexOf('application/json') !== -1) {
    const data = await response.json();
    if (!data.isSuccessfull) {
      hasError = true;
      if (mouseflowId) {
        window._mfq.push(['formSubmitFailure', mouseflowId]);
      }
      resultDivs.forEach((resultDiv) => (resultDiv.innerHTML = data.message));
    } else if (mouseflowId) {
      window._mfq.push(['formSubmitSuccess', mouseflowId]);
    }
  } else {
    const text = await response.text();
    window.gtmNewsletterSubscribed(text);
    if (mouseflowId) {
      if (text.includes('Fehler') || text.includes('erneut')) {
        window._mfq.push(['formSubmitFailure', mouseflowId]);
      } else {
        window._mfq.push(['formSubmitSuccess', mouseflowId]);
      }
    }
    resultDivs.forEach((resultDiv) => (resultDiv.innerHTML = text));
  }

  const setSfmcId = () => {
    console.log('setSfmcId called');
    const cidInput = document.querySelector("input[type='hidden'][name='cid']");
    let cid = '';
    if (cidInput !== null) {
      cid = cidInput.value;
    }
    if (Cookiebot.consent.marketing) {
      let date = new Date();
      date.setTime(date.getTime() + 10 * 365 * 24 * 60 * 60 * 1000);
      let dateStr = date.toUTCString();
      document.cookie = `SfmcId=${cid}; expires=${dateStr}`;
    }
  };

  setSfmcId();
  if (hasError === false && callback && typeof callback === 'function') {
    callback();
  }
};

/** @param {HTMLFormElement} form */
function sfShowLoadingIndicator(form) {
  const ring = form.querySelector('#loading-indicator');
  ring.setAttribute('style', 'display:block');
}
